import { ReactElement } from 'react';

import { Status } from '@dreryk/egabinet-waitlist-frontend-api';

import { BindingCreator, useTranslate } from '@dreryk/react-common';
import { FilterPanel, Multiselect } from '@dreryk/react-components';

import {
   WaitlistFilterPanelFormBean,
   WaitlistFilterPanelSearchParam,
   WaitlistFilterPanelStorageKey,
} from '../../WaitlistFilterPanel.types';
import { translationKeys } from '../../../translations';

import {
   createStatusTriggerLabelExtractor,
   STATUSES,
   statusesCodec,
   statusesDeselectorsPropsMapper,
} from './StatusController.utils';
import { StyledReservationPreferenceMultiselect } from './StatusMultiselect.styled';

type ReservationPreferenceControllerProps = {
   registerController: BindingCreator<WaitlistFilterPanelFormBean, 'statuses'>;
};

export const StatusController = (props: ReservationPreferenceControllerProps): ReactElement => {
   const translate = useTranslate();
   return (
      <FilterPanel.Controller<WaitlistFilterPanelFormBean, 'statuses'>
         name={'statuses'}
         searchParam={WaitlistFilterPanelSearchParam.STATUS}
         storageKey={WaitlistFilterPanelStorageKey.STATUS}
         codec={statusesCodec}
         chipsLabel={translationKeys.status}
         getDeselectorsProps={statusesDeselectorsPropsMapper}
      >
         {({ applyFilter }) => (
            <StyledReservationPreferenceMultiselect<Status>
               testId={'statuses'}
               triggerLabelExtractor={createStatusTriggerLabelExtractor(translate)}
               controller={props.registerController('statuses')}
               onHide={applyFilter}
               label={translationKeys.status}
               placeholder={translationKeys.choosePriority}
               compact
            >
               <>
                  <Multiselect.SelectAll testId={'selectAllStatuses'} items={STATUSES} />
                  <Multiselect.List<Status> items={STATUSES}>
                     {(item) => (
                        <Multiselect.Item item={item} label={translationKeys.statusDescription[item]} testId={item} />
                     )}
                  </Multiselect.List>
               </>
            </StyledReservationPreferenceMultiselect>
         )}
      </FilterPanel.Controller>
   );
};
